import classNames from "classnames";

// Be careful with this component. It *does not* disable keyboard events (i.e. tabbing and typing)
export function Disabler(props: {
	children: React.ReactNode;
	disabled: boolean;
}) {
	return (
		<div
			className={classNames({
				"disable-children-pointer-events cursor-not-allowed opacity-70":
					props.disabled,
			})}
		>
			{props.children}
		</div>
	);
}
